import { render, staticRenderFns } from "./AddObsModal.vue?vue&type=template&id=49ea7107&scoped=true"
import script from "./AddObsModal.vue?vue&type=script&lang=js"
export * from "./AddObsModal.vue?vue&type=script&lang=js"
import style0 from "./AddObsModal.vue?vue&type=style&index=0&id=49ea7107&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ea7107",
  null
  
)

export default component.exports